import React from 'react';
import ActivitesForm from '.././Activites/ActivitesForm';
import EvenementsForm from '.././Evenements/EvenementsForm';
import SeancesForm from '.././Seances/SeancesForm';

export default function RadioGroup({ formData, handleChange }) {
  return (
    <>
      <div className="radio-group">
        <label><br/>Catégorie :</label>
        <input type="radio" name="categorie" value="activite"  onChange={handleChange}/>  Activité(s)<br/>
        <input type="radio" name="categorie" value="evenement" onChange={handleChange}/>  Événement(s)<br />
        <input type="radio" name="categorie" value="seance" onChange={handleChange}/>  Séance(s)/Réunion(s)<br />
      </div>

      {formData.categorie === 'activite' && <ActivitesForm formData={formData} handleChange={handleChange} />}
      {formData.categorie === 'evenement' && <EvenementsForm formData={formData} handleChange={handleChange} />}
      {formData.categorie === 'seance' && <SeancesForm formData={formData} handleChange={handleChange} />}
    </>
  );
}
